/**
 * Auth Page — Now uses professional Landing Page
 * SESSION 131: Complete landing page redesign
 */
import React from 'react';
import { LandingPage } from './LandingPage';

// Main Login/Landing Page - Now uses the professional LandingPage component
export const LoginPage = LandingPage;

// Backward compatibility: export AuthPage as alias for LoginPage
export const AuthPage = LandingPage;

export default LandingPage;
